import type { FunctionComponent } from 'react';

import { useUnreadNotificationCount } from './api/use-unread-notification-count';

export const UnreadNotificationsDot: FunctionComponent = () => {
    const { unreadCount } = useUnreadNotificationCount();

    if (unreadCount === 0) {
        return null;
    }

    return (
        <span
            className="side-nav-unread-dot pointer-events-none absolute -right-px -top-px size-1.5 rounded-full bg-orange-800"
            data-testid="unread-notifications-dot"
        />
    );
};
